<template>
    <section id="testimony-section" class="my-20" :class="context.isDarkMode ? 'bg-void' : 'bg-white'">

        <div class="w-full mt-10">
            <img src="@/assets/images/quote-icon.svg" width="50" height="50" class="mx-auto">
        </div>
        <p 
            class="text-4xl xl:text-2xl 2xl:text-4xl font-semibold text-center mt-5 mb-10" 
            :class="context.isDarkMode ? 'text-silver' : 'text-void'"
        >
            {{ translationHandler.translate('testimonies', 'ucfirst') }}
        </p>

        <div class="w-full md:w-3/4 xl:w-2/4 px-5 md:px-10 mx-auto">
            <Carousel :value="testimoniesList" :numVisible="1" :numScroll="1" :circular="true" :showNavigators="addNavigators">
                <template #item="slotProps">
                    <div 
                        class="text-center px-5 py-10 border rounded-xl"
                        :class="context.isDarkMode ? 'border-semidark-silver bg-semidark-silver text-silver' : 'border-light-white'"
                    >
                        <div class="relative text-center">
                            <img :src="slotProps.data.image" width="150" height="150" class="rounded-2xl mx-auto">
                        </div>

                        <p class="my-5 font-bold text-xl">
                            {{ slotProps.data.name }}, {{ translationHandler.translate(slotProps.data.profession, 'ucfirst') }}.
                        </p>

                        <p class="font-normal text-lg italic">
                            "{{ translationHandler.translate(slotProps.data.feedback, 'ucfirst') }}"
                        </p>

                        <span class="flex flex-row gap-2 justify-center my-10">
                            <i 
                                v-for="(score, index) of slotProps.data.score" 
                                :key="index"
                                class="pi pi-star-fill"
                                style="color: #f0ad4e"
                            ></i>
                        </span>
                    </div>
                </template>
            </Carousel>
        </div>
    </section>
</template>

<script setup>
import translationHandler from '@/composables/handlers/TranslationHandler';
import { useContextStore } from '@/stores/context';
import Carousel from 'primevue/carousel';
import { onMounted, onUnmounted, ref } from 'vue';

const context = useContextStore();
const windowWidth = ref(window.innerWidth);
const breakPoint = 500;
const addNavigators = ref(true);

onMounted(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    isScreenSmall();
});

onUnmounted(() => {
    window.removeEventListener('resize', handleResize);
});

function isScreenSmall(){
    return windowWidth.value > breakPoint ? false : true;
}

function handleResize(){
    windowWidth.value = window.innerWidth;
    addNavigators.value = !isScreenSmall();
}

const testimoniesList = ref([
    {
        name: 'Rafael Souza',
        profession: 'logistics company operations manager',
        feedback: "the automation solution they implemented completely changed our workflow. tasks that used to take hours are now done in minutes. with the time saved, our team can focus on strategic improvements, and the system's accuracy eliminated manual errors. it was an investment that paid for itself in less than a month.",
        image: require('@/assets/images/testimonies/testimony-rafael.jpg'),
        score: 5
    },
    {
        name: 'Juliana Costa',
        profession: 'owner of an architecture firm',
        feedback: 'we needed a website that was more than just a portfolio; we wanted a platform that reflected our professionalism. they not only delivered an impeccable design, but also a tailor-made system for us to manage our projects. the result is a website that inspires confidence and puts us on a whole new level in the market.',
        image: require('@/assets/images/testimonies/testimony-juliana.jpg'),
        score: 5
    },
    {
        name: 'Luis Bittencourt',
        profession: 'founder of an online fashion store',
        feedback: 'my online store has never been so good. the e-commerce that the agency built for us is fast, elegant and, most importantly, easy for customers to navigate. our revenue has increased considerably in a short time and, for the first time, I feel I have a store that really works 24/7.',
        image: require('@/assets/images/testimonies/testimony-luiz.jpg'),
        score: 5
    },
]);

</script>